"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function usePregeneratedHashes(hashes) {
    return function (doc) {
        var operationDefinition = doc.definitions.find(function (def) { return def.kind === "OperationDefinition"; });
        if (!operationDefinition ||
            operationDefinition.kind !== "OperationDefinition") {
            console.error("Cannot find OperationDefinition from", doc);
            throw new Error("Operation missing from graphql query");
        }
        if (!operationDefinition.name) {
            throw new Error("name missing from operation definition");
        }
        var hash = hashes[operationDefinition.name.value];
        if (!hash) {
            throw new Error("Cannot find pregerated has for " +
                operationDefinition.name.value);
        }
        return hash;
    };
}
exports.usePregeneratedHashes = usePregeneratedHashes;
//# sourceMappingURL=apollo.js.map